import { ThumbnailsSettings } from "../../views/ThumbnailsSettings";

export function Thumbnails() {
    return (
        <>
            <ThumbnailsSettings />
        </>
    );
}
